import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import helperFunction from "../../Function/helperFunction";
import { DataService } from "../../Services/dataService";
import { BiExport, BiImport } from "react-icons/bi";
import { toast } from "react-toastify";

export const HsCodeRequestsList = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    try {
      setLoading(true);
      const res = await DataService.get("/admin/hscode/requests");
      if (res.status && res.data) {
        setRequests(res.data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusUpdate = async (id, status) => {
    if (!window.confirm(`Are you sure you want to mark this request as ${status}?`)) return;
    try {
      const res = await DataService.put(`/admin/hscode/request/${id}/status`, { status });
      if (res.status) {
        helperFunction.toast("Status updated successfully", "success");
        fetchRequests();
      } else {
        helperFunction.toast(res.message || "Error updating status", "error");
      }
    } catch (e) {
      console.error(e);
      helperFunction.toast("Error updating status", "error");
    }
  };

  const handleDownloadPending = async (id) => {
    try {
      setLoading(true);
      const res = await DataService.get(`/admin/hscode/requests/export/${id}`);
      if (res.status) {
        window.location.href = process.env.REACT_APP_API_BASEURL + "/" + res.data;
      } else {
        toast.error(res.message || "Error downloading file");
      }
    } catch (e) {
      console.error(e);
      toast.error("Error downloading file");
    } finally {
      setLoading(false);
    }
  };

  const handleUploadApprove = async (e, id) => {
    try {
      const file = e.target.files[0];
      if (!file) return;
      
      setLoading(true);
      const formData = new FormData();
      formData.append("csv_file", file);
      
      const res = await DataService.post(`/admin/hscode/requests/import/${id}`, formData);
      if (res.status) {
        toast.success(res.msg || "File imported and requests approved successfully");
        fetchRequests(); // refresh list
      } else {
        toast.error(res.message || "Error uploading file");
      }
    } catch (e) {
      console.error(e);
      toast.error("Error uploading file");
    } finally {
      setLoading(false);
      e.target.value = null;
    }
  };

  const handleApproveAdd = (request) => {
    // Redirect to Add Duty and Tax module with parameters
    const hsCodeToPreFill = Array.isArray(request.hs_codes) ? request.hs_codes[0] : request.hs_codes;
    history.push(`/add-duty-and-tax?requestId=${request._id}&hsCode=${hsCodeToPreFill}`);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive table-bordered">
                <table className="table table-striped table-nowrap mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Date</th>
                      <th>Retailer</th>
                      <th>HS Code(s)</th>
                      <th>Product Info</th>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="6" className="text-center">Loading...</td>
                      </tr>
                    ) : requests.length > 0 ? (
                      requests.map((req, idx) => (
                        <tr key={idx}>
                          <td className="text-body align-middle">{new Date(req.created_at).toLocaleDateString()}</td>
                          <td className="text-body align-middle">
                            {req.retailer_id?.retailer_name} 
                            <br />
                            <small className="text-muted">{req.retailer_id?.email}</small>
                          </td>
                          <td className="text-body align-middle">{Array.isArray(req.hs_codes) ? req.hs_codes.join(", ") : req.hs_codes}</td>
                          <td className="text-body align-middle" style={{ maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={req.product_data ? (req.product_data.description || req.product_data.product_name || JSON.stringify(req.product_data)) : 'N/A'}>
                            {req.product_data ? (req.product_data.description || req.product_data.product_name || 'View Details') : 'N/A'}
                          </td>
                          <td className="text-body align-middle" style={{textTransform: 'capitalize'}}>{req.request_type}</td>
                          <td className="align-middle">
                            <span className={`badge px-2 py-1 ${req.status === 'Approved' ? 'bg-success text-white' : req.status === 'Rejected' ? 'bg-danger text-white' : 'bg-warning text-dark'}`}>
                              {req.status}
                            </span>
                          </td>
                          <td className="align-middle">
                            {req.status === 'Pending' && (
                              <div className="d-flex align-items-center">
                                <button className="btn btn-sm btn-success me-2 waves-effect waves-light" onClick={() => handleDownloadPending(req._id)} title="Download Request Excel">Download</button>
                                

                                <button className="btn btn-sm btn-outline-danger waves-effect waves-light" onClick={() => handleStatusUpdate(req._id, 'Rejected')}>Reject</button>
                              </div>
                            )}
                            {req.status === 'Approved' && (
                              <span className="text-success font-weight-bold">Added</span>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">No requests found.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
